import "antd/es/alert/style";
import _Alert from "antd/es/alert";
var _excluded = ["showIcon", "icon", "type", "className", "style", "description", "message"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { InfoFilled, AlertFilled, SuccessFilled } from 'iglooicon';
import Typography from '../typography';
import './style/index.less';
var prefix = 'igloo-alert-message';

function judgeIconType(iconProps, type) {
  if (iconProps) return iconProps;

  switch (type) {
    case 'info':
      return _jsx(InfoFilled, {
        className: "".concat(prefix, "-icon ").concat(prefix, "-info-icon")
      });

    case 'warning':
      return _jsx(AlertFilled, {
        className: "".concat(prefix, "-icon ").concat(prefix, "-warning-icon")
      });

    case 'error':
      return _jsx(AlertFilled, {
        className: "".concat(prefix, "-icon ").concat(prefix, "-error-icon")
      });

    case 'success':
      return _jsx(SuccessFilled, {
        className: "".concat(prefix, "-icon ").concat(prefix, "-success-icon")
      });
  }
}

var IglooAlertMessage = function IglooAlertMessage(props) {
  var _classnames;

  var _props$showIcon = props.showIcon,
      showIcon = _props$showIcon === void 0 ? true : _props$showIcon,
      icon = props.icon,
      type = props.type,
      className = props.className,
      style = props.style,
      description = props.description,
      message = props.message,
      restProps = _objectWithoutProperties(props, _excluded);

  return _jsx(_Alert, _objectSpread({
    className: classnames((_classnames = {
      'igloo-alert-message': true
    }, _defineProperty(_classnames, "".concat(prefix, "-").concat(type), true), _defineProperty(_classnames, className, className), _classnames)),
    style: style,
    showIcon: showIcon,
    icon: judgeIconType(icon, type),
    type: type,
    message: _jsx(Typography, {
      level: "body2",
      children: message
    }),
    description: description && _jsx(Typography, {
      level: "body2",
      children: description
    })
  }, restProps));
};

export default IglooAlertMessage;